// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ec812cb5","453":"8bafa1c4"}[chunkId] + ".chunk.js";
};